import React, { useContext } from "react";
import { UserContext } from "../UserContext";
import { Button } from "./ui/button";
import { ref, remove, set } from "firebase/database";
import { database } from "../firebaseConfig";
import { ThumbsUp } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PublicListing = ({ list, listId }) => {
  const { users, currentUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLikeList = (listId) => {
    const likesRef = ref(database, `lists/${listId}/likes/${currentUser.uid}`);
    set(likesRef, true).catch((error) => {
      console.error("Error liking list:", error);
      alert("Failed to like list. Please try again.");
    });
  };

  const handleUnlikeList = (listId) => {
    const likesRef = ref(database, `lists/${listId}/likes/${currentUser.uid}`);
    remove(likesRef).catch((error) => {
      console.error("Error unliking list:", error);
      alert("Failed to unlike list. Please try again.");
    });
  };

  const handleViewList = (listId) => {
    navigate(`/list/${listId}`);
  };

  return (
    <li className="bg-gray-900 rounded-lg p-4 transition-all hover:shadow-lg">
      <h3 className="text-lg font-semibold text-gray-300">{list?.name}</h3>
      <p className="text-gray-400">
        {Object.keys(list?.data || {})?.length} items
      </p>
      <p className="text-gray-400">
        Created by: {users[list?.createdBy]?.displayName || "Unknown User"}
      </p>
      <p className="text-gray-400">
        Likes: {Object.keys(list?.likes || {})?.length}
      </p>
      <div className="flex justify-between items-center mt-2">
        <Button
          variant="outline"
          className="border-gray-300 text-gray-300 hover:bg-gray-700"
          onClick={() => handleViewList(listId)}
        >
          View List
        </Button>
        {currentUser && (
          <Button
            variant="outline"
            size="icon"
            onClick={() =>
              list?.likes && list?.likes[currentUser?.uid]
                ? handleUnlikeList(listId)
                : handleLikeList(listId)
            }
            className="border-gray-300 text-gray-300 hover:bg-gray-700 p-2"
          >
            <ThumbsUp
              className={`h-4 w-4 ${
                list?.likes && list?.likes[currentUser?.uid]
                  ? "fill-current"
                  : ""
              }`}
            />
          </Button>
        )}
      </div>
    </li>
  );
};

export default PublicListing;
